<template>
  <v-expansion-panels 
    v-model="open" 
    multiple
    :readonly="!isExpanded"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <div class="expandable-panel-title G2--text my-4">
            <slot name="expandablePanelHeader">
              <!-- there Goes HEADER -->
            </slot>
          </div>
          <AppPortalTarget
            :name="`${def.id}.rightSection`"
            class="expandable-panel-portal-right G2--text my-4"
          >
          </AppPortalTarget>
        </div>
        <AppPortalTarget
          :name="`${def.id}.leftSection`"
          class="expandable-panel-portal-left"
        >
        </AppPortalTarget>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="py-8 px-5">
        <slot name="expandablePanelContent">
          <!-- there Goes CONTENT -->
        </slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import AppPortalTarget from "@/components/library/portal/AppPortalTarget"

export default {
  name: "AppExpandablePanel",
  components : {AppPortalTarget},
  props:['def'],
  data: () => ({
    open: [0],
    isExpanded : true
  }),
  methods : {
    onExpanded(payload) {
      this.isExpanded = payload;
      payload ? this.$set(this.open, 0, 0) : this.open.pop();
    }
  }
};
</script>
<style>
.expandable-panel-title{
  width: 200px;
  display: inline-block;
  line-height: 28px;
  min-width: 26%;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  
}
.expandable-panel-portal-left{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-left: 10px;
}
.expandable-panel-portal-right{
  display: inline-block;
  font-size: 12px;
  line-height: 21px;
  padding-right: 18px;
}
</style>
